const MARKDOWN_LABEL_ESCAPE = /[\\[\]()]/g;

export function convertSlackMrkdwnLinks(text: string): string {
  return text.replace(/<(https?:\/\/[^<>]+)>/gi, (token, inner: string) => {
    const { label, url } = splitSlackLinkInner(inner);
    if (!isSafeHttpUrl(url)) {
      return token;
    }
    const displayText = label?.trim() ? escapeMarkdownLabel(label) : url;
    return `[${displayText}](${url})`;
  });
}

function splitSlackLinkInner(inner: string): { label?: string; url: string } {
  const pipeIndex = inner.indexOf('|');
  if (pipeIndex === -1) {
    return { url: inner };
  }
  return {
    label: inner.slice(pipeIndex + 1),
    url: inner.slice(0, pipeIndex),
  };
}

function isSafeHttpUrl(url: string): boolean {
  if (/[\s()[\]]/.test(url)) {
    return false;
  }
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}

function escapeMarkdownLabel(label: string): string {
  return label.replace(MARKDOWN_LABEL_ESCAPE, '\\$&');
}
